import React, { FC } from 'react';

import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

import { AbstractIcon } from '../abstract-icon';

interface Props {
  className?: string;
}

const ChevronLeftIcon: FC<Props> = props => <AbstractIcon {...props} icon={faChevronLeft} />;

export { ChevronLeftIcon };